import type { IEntitiesStore } from 'entities/EntitiesExport'
import { OutboundKey } from 'widgets/Menu/ui/MenuOutbound/constants/menuItems'
import { getPath } from 'widgets/Menu/ui/MenuOutbound/lib/getPathOutbound'
import { usePathMenu } from 'widgets/Menu/hooks/usePathMenu'

export const usePathOutbound = (userId: number, entities: IEntitiesStore) => {
  return usePathMenu(`${userId}_menu_${OutboundKey}`, (path) => {
    return getPath(path, entities)
  })
}
